<template>
  <div class="container">
    <div class="jumbotron mt-5">
      <div class="col-sm-8 mx-auto">
        <h1 class="text-center">Saját fiók</h1>
      </div>
      <table class="table col-md-6 mx-auto">
        <tbody>
          <tr>
            <td>Kersztnév</td>
            <td>{{list.first_name}}</td>
          </tr>
          <tr>
            <td>Vezetéknév</td>
            <td>{{list.last_name}}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{{list.email}}</td>
          </tr>
          <tr>
            <td>Monogram</td>
            <td>{{list.monogram}}</td>
          </tr>
          <tr>
            <td>Kétlépcsős azonosítás</td>
            <td>
              <span v-if="list.twoFactorEnabled" class="text-success">Bekapcsolva</span>
              <span v-else class="text-danger">Kikapcsolva</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="button-group text-center">
        <b-button
          size="sm"
          variant="primary"
          @click="$router.push({
                    name: 'UserNew',
                    params: { email: email}
                  })"
        >
          <b-icon-pencil></b-icon-pencil>
          Szerkesztés
        </b-button>

        <b-button
          size="sm"
          variant="warning"
          @click="$router.push({
                    name: 'UserNewPassword',
                    params: { email: email}
                  })"
        >
          <b-icon-pencil></b-icon-pencil>
          Jelszó váltás
        </b-button>

        <b-button
          v-if="!list.twoFactorEnabled"
          size="sm"
          variant="success"
          @click="enable2fa"
        >
          <b-icon-shield-lock></b-icon-shield-lock>
          2FA Bekapcsolása
        </b-button>

        <b-button
          v-else
          size="sm"
          variant="danger"
          @click="disable2fa"
        >
          <b-icon-shield-slash></b-icon-shield-slash>
          2FA Kikapcsolása
        </b-button>
      </div>

      <!-- 2FA Setup Modal -->
      <b-modal id="modal-2fa" title="Kétlépcsős azonosítás beállítása" hide-footer>
        <div class="text-center">
          <p>Olvasd be az alábbi QR kódot a Google Authenticator alkalmazással:</p>
          <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="2FA QR Code" class="img-fluid mb-3" />
          
          <div class="form-group">
            <label>Ellenőrző kód:</label>
            <input type="text" class="form-control" v-model="verificationCode" placeholder="Írd be a 6 számjegyű kódot">
          </div>
          
          <div v-if="setupError" class="alert alert-danger">{{ setupError }}</div>

          <b-button variant="success" block @click="verify2fa">Aktiválás</b-button>
        </div>
      </b-modal>

    </div>
  </div>
</template>

<script>

import axios from 'axios'
import jwtDecode from 'jwt-decode'
import router from '../router'

export default {
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      userType : decoded.usertype,
      first_name: decoded.first_name,
      last_name: decoded.last_name,
      monogram: decoded.monogram,
      email: decoded.email,
      list: [],
      qrCodeUrl: '',
      verificationCode: '',
      setupError: ''
    }
  },
  methods: {
    enable2fa() {
      axios.post('https://'+process.env.ROOT_API+'/users/2fa/generate', { id: this.list.id })
        .then(res => {
          this.qrCodeUrl = res.data.data_url
          this.$bvModal.show('modal-2fa')
        })
        .catch(err => {
          console.log(err)
        })
    },
    verify2fa() {
      axios.post('https://'+process.env.ROOT_API+'/users/2fa/verify', { 
        id: this.list.id,
        token: this.verificationCode
      })
      .then(res => {
        if (res.data.verified) {
          this.list.twoFactorEnabled = true
          this.$bvModal.hide('modal-2fa')
          this.verificationCode = ''
          this.setupError = ''
        } else {
          this.setupError = 'Hibás kód!'
        }
      })
      .catch(err => {
        console.log(err)
        this.setupError = 'Hiba történt a verifikáció során.'
      })
    },
    disable2fa() {
      if(confirm('Biztosan ki szeretnéd kapcsolni a kétlépcsős azonosítást?')) {
        axios.post('https://'+process.env.ROOT_API+'/users/2fa/disable', { id: this.list.id })
          .then(res => {
            if (res.data.success) {
              this.list.twoFactorEnabled = false
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      payload.token = this.token
      payload.email = this.email
      payload.userType = this.userType
      axios
        .post('https://'+process.env.ROOT_API+'/users/profile', { payload })
        .then(res => {
          this.list = res.data
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}  
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue